<script lang="ts" setup>
  import Status from '@/common/shared/Status.vue';
  import { useNotificationsStore } from '@/common/store/pinia/notifications';
  import { computed } from 'vue';
  import TooltipWrapper from '@/common/shared/TooltipWrapper.vue';

  const props = defineProps<{
    notificationId: string
  }>();

  const notificationsStore = useNotificationsStore();

  const data = computed(() => {
    const notification = notificationsStore.getItemById(props.notificationId);
    return notification?.inProgressItems || [];
  });
</script>

<template>
  <el-table
    class="v-deleting-items-table"
    :data="data"
    rowKey="id"
  >
    <el-table-column
      sortable
      :label="$t('Name')"
      prop="name"
    >
      <template #default="{ row }">
        <tooltip-wrapper
          :tooltip-text="row.name"
        >
          <el-icon
            v-if="row.icon"
            class="mr-16"
            color="brand-primary"
            size="24"
            :name="row.icon"
          /><span>{{ row.name }}</span>
        </tooltip-wrapper>
      </template>
    </el-table-column>
    <el-table-column
      sortable
      :label="$t('Status')"
      prop="statusText"
    >
      <template #default="{ row }">
        <status :status="row.statusIcon">
          {{ row.statusText }}
        </status>
      </template>
    </el-table-column>
  </el-table>
</template>
